import { render, staticRenderFns } from "./AdminProductList.vue?vue&type=template&id=b8226cbe"
import script from "./AdminProductList.vue?vue&type=script&lang=js"
export * from "./AdminProductList.vue?vue&type=script&lang=js"
import style0 from "./AdminProductList.vue?vue&type=style&index=0&id=b8226cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports